import type { ReactNode } from "react";
import { Badge } from "@/shared/components/ui/badge";

/// Compact "Invited" marker for a pending (invited, not-yet-accepted) member.
/// Mirrors the People directory table badge so the signal reads the same
/// wherever invited members surface (directory, kudos / feedback pickers).
export function InvitedBadge(): ReactNode {
  return (
    <Badge
      variant="outline"
      className="h-4 shrink-0 border-amber-200 bg-amber-50 px-1.5 py-0 text-3xs font-semibold uppercase tracking-wider text-amber-700 dark:border-amber-900/60 dark:bg-amber-900/30 dark:text-amber-200"
    >
      Invited
    </Badge>
  );
}
